import { REVENUE_MANAGEMENT_ROOT_ENDPOINT } from "./RootEndpoint";

const PATH_PROMOTION_CHARGE = `${REVENUE_MANAGEMENT_ROOT_ENDPOINT}/promotion-charge`;

export const PROMOTION_CHARGE_GET_ALL = PATH_PROMOTION_CHARGE;
export const PROMOTION_CHARGE_GET_ONE = `${PATH_PROMOTION_CHARGE}/%s`;
export const PROMOTION_CHARGE_CREATE = PATH_PROMOTION_CHARGE;
export const PROMOTION_CHARGE_UPDATE = `${PATH_PROMOTION_CHARGE}/%s`;
export const PROMOTION_CHARGE_REMOVE = `${PATH_PROMOTION_CHARGE}/%s`;
